import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import toast from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, deleteSkill } from '../utils/delete-skill';

export function useDeleteSkill() {
  const { client } = useApi();

  return useSWRMutation(
    'delete-quark-skill',
    (key, { arg }: SWRArgs<ParamsSchemaT>) => {
      return toast.promise(deleteSkill(client, arg), {
        loading: t`Suppression de la compétence...`,
        success: t`La compétence a bien été supprimée.`,
        error: t`Une erreur est survenue lors de la suppression de la compétence.`,
      });
    }
  );
}
